import "./Teachers.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import AddTeacherForm from "../../../Components/Organisms/Forms/AddTeacherForm/AddTeacherForm";
import { PulseLoader } from "react-spinners";
import { BaseURL } from "../../../Hooks/URL";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import { images } from "../../../Assets/assetsHelper";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../../../Components/Molecules/Filter/Filter";
import { Box, Grid, Pagination, Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#012369",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const adminColumns = [
  {
    id: "photo",
    label: "",
    minWidth: 50,
  },
  { id: "name", label: "Name", minWidth: 150 },
  {
    id: "email",
    label: "Email Address",
    minWidth: 170,
  },
  {
    id: "gender",
    label: "Gender",
    minWidth: 70,
  },
  {
    id: "phone",
    label: "Phone Number",
    minWidth: 170,
  },
  {
    id: "national_id",
    label: "National ID",
    minWidth: 170,
  },
  {
    id: "school",
    label: "School Hire From",
    minWidth: 150,
  },
  { id: "activated", label: "Activated", maxWidth: 50, align: "center" },
];

const columns = [
  {
    id: "photo",
    label: "",
    minWidth: 50,
  },
  { id: "name", label: "Name", minWidth: 150 },
  {
    id: "email",
    label: "Email Address",
    minWidth: 170,
  },
  {
    id: "gender",
    label: "Gender",
    minWidth: 70,
  },
  {
    id: "phone",
    label: "Phone Number",
    minWidth: 170,
  },
  {
    id: "national_id",
    label: "National ID",
    minWidth: 170,
  },
  { id: "activated", label: "Activated", maxWidth: 50, align: "center" },
];

function Teachers({
  role,
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  teachers,
  navigate,
  handleChangePage,
  Open,
  setOpen,
  loading,
  data,
  error,
  pageCount,
  setTeachers,
  addLoading,
  setActivateClicked,
  activateClicked,
  setFilter,
}) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <FormModal
          Open={Open}
          HandleClose={() => {
            setOpen(false);
          }}
          Form={
            <AddTeacherForm
              Edit={false}
              setOpen={setOpen}
              Open={Open}
              setTeachers={setTeachers}
              page={page}
              search={search}
            />
          }
          Title={"Add New Instructor"}
        />
        <div className="header">
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search"}
              className="SearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search != searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13)
                  if (search != searchData) {
                    setSearch(searchData);
                  }
              }}
            />
            {/* <Filter Gender schools activated setFilter={setFilter} /> */}
          </div>
          <PrimaryButton
            classBtn={"center addButton"}
            text={"Add Instructor"}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: "var(--text-secondary)",
              backgroundColor: "var(--primary)",
              height: "45px",
              padding: "0 30px",
              minWidth: "100px",
              textWrap: "noWrap",
            }}
            click={() => {
              setOpen(true);
            }}
          />
        </div>
        {teachers && !loading ? (
          <>
            <Grid container sx={{ width: "100%" }}>
              {teachers.map((teacher) => (
                <Grid item xs={6} sm={4} md={3} lg={12 / 5}>
                  <Box
                    sx={{
                      background: "white",
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "10px",
                      height: "calc(100% - 20px)",
                      m: "10px",
                      cursor: "pointer",
                      position: "relative",
                      ":hover": {
                        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.3)",
                        transform: "translateY(1px)",
                      },
                    }}
                    onClick={() => {
                      navigate(`/instructors/${teacher.id}`);
                    }}
                  >
                    {!teacher?.activated ? (
                      <div
                        style={{
                          borderRadius: "10px 0 0",
                          padding: "3px 5px 3px 7px",
                          position: "absolute",
                          top: "0",
                          left: "0",
                          backgroundColor: "red",
                          color: "white",
                          fontSize: "10px",
                        }}
                      >
                        Not Activated
                      </div>
                    ) : (
                      ""
                    )}
                    <img
                      alt="photo"
                      width={"80%"}
                      src={
                        teacher?.photo
                          ? `${BaseURL}/images/${teacher?.photo}`
                          : images.TeacherPlace
                      }
                      style={{
                        margin: "auto",
                        minHeight: "80px",
                        borderRadius: "50%",
                      }}
                    />
                    <Typography
                      sx={{
                        display: "block",
                        fontSize: { xs: "15px", md: "18px" },
                        textAlign: "center",
                        fontWeight: "600",
                        marginTop: "5px",
                      }}
                    >
                      {teacher?.name}
                    </Typography>
                    {role == 1 ? (
                      <Typography
                        sx={{
                          display: "block",
                          fontSize: { xs: "14px", md: "16px" },
                          textAlign: "center",
                        }}
                      >
                        school: {teacher?.school?.name ?? "Skill Code"}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
            {!teachers?.length ? (
              <h3 style={{ textAlign: "center", margin: "50px" }}>
                No Teachers Added Yet!!
              </h3>
            ) : (
              ""
            )}
            <Pagination
              className="paginationCount"
              count={pageCount}
              page={page + 1}
              onChange={handleChangePage}
              size="large"
            />
          </>
        ) : (
          <div className="loadingBox">
            <PulseLoader color="#012369" />
          </div>
        )}
        {/* <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {teachers && !loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {role == 1
                        ? adminColumns.map((column) => (
                            <StyledTableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                              }}
                            >
                              {column.label}
                            </StyledTableCell>
                          ))
                        : columns.map((column) => (
                            <StyledTableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                              }}
                            >
                              {column.label}
                            </StyledTableCell>
                          ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teachers.map((teacher) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={teacher.id}
                          onClick={() => {
                            navigate(`/instructors/${teacher.id}`);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {role == 1
                            ? adminColumns.map((column) => {
                                const value = teacher[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ padding: "10px" }}
                                  >
                                    {column.id === "photo" ? (
                                      <img
                                        alt="photo"
                                        width={"50px"}
                                        height={"50px"}
                                        src={
                                          value
                                            ? `${BaseURL}/images/${value}`
                                            : images.TeacherPlace
                                        }
                                        style={{
                                          margin: "auto",
                                          borderRadius: "50%",
                                        }}
                                      />
                                    ) : (
                                      <>
                                        {column.id === "gender" && value ? (
                                          <>{value == 1 ? "Male" : "Female"}</>
                                        ) : column.id == "school" ? (
                                          !value ? (
                                            "Skill Code"
                                          ) : (
                                            value?.name
                                          )
                                        ) : column.id === "activated" ? (
                                          value ? (
                                            <DoneIcon className="activatedTick" />
                                          ) : (
                                            <CloseIcon className="NonActivatedTick" />
                                          )
                                        ) : (
                                          value
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                );
                              })
                            : columns.map((column) => {
                                const value = teacher[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ padding: "10px" }}
                                  >
                                    {column.id === "photo" ? (
                                      <img
                                        alt="photo"
                                        width={"50px"}
                                        height={"50px"}
                                        src={
                                          value
                                            ? `${BaseURL}/images/${value}`
                                            : images.TeacherPlace
                                        }
                                        style={{
                                          margin: "auto",
                                          borderRadius: "50%",
                                        }}
                                      />
                                    ) : (
                                      <>
                                        {column.id === "gender" && value ? (
                                          <>{value == 1 ? "Male" : "Female"}</>
                                        ) : column.id == "school" ? (
                                          !value ? (
                                            "Skill Code"
                                          ) : (
                                            value?.name
                                          )
                                        ) : column.id === "activated" ? (
                                          value ? (
                                            <DoneIcon className="activatedTick" />
                                          ) : (
                                            <CloseIcon className="NonActivatedTick" />
                                          )
                                        ) : (
                                          value
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                );
                              })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!teachers?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No Teachers Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={pageCount * rowsPerPage}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          ) : (
            <div className="loadingBox">
              <PulseLoader color="#012369" />
            </div>
          )}
        </Paper> */}
      </div>
    </div>
  );
}

export default Teachers;
